import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.VUE_APP_API_URL;

class VmsSetupService {
  checklist(organizationId = null) {
    return axios.get(API_URL + "vms-setup-checklist", {
      params: organizationId ? { organization_id: organizationId } : {},
      headers: authHeader(),
    });
  }
}

export default new VmsSetupService();
